var _linearGradient, _circle, _defs, _mask, _g, _defs2, _mask2, _g2, _defs3, _mask3, _g3, _defs4, _mask4, _g4, _defs5, _mask5, _g5, _defs6, _mask6, _g6, _defs7, _mask7, _g7, _defs8, _mask8, _g8, _defs9, _mask9, _g9, _defs0, _mask0, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTanstackBackgroundLogo = function SvgTanstackBackgroundLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 633 633"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__a",
    x1: -666.45,
    x2: -666.45,
    y1: 163.28,
    y2: 163.99,
    gradientTransform: "matrix(633 0 0 633 422177 -103358)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F9FFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7373"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "url(#tanstack-background-logo_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__b",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 412,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__c",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 412,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 610.5,
    fill: "#015064",
    stroke: "#00CFE2",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__d",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 412,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__e",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 412,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__e)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.5,
    cy: 610.5,
    fill: "#015064",
    stroke: "#00CFE2",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__f",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 450,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__g",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 450,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__g)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 648.5,
    fill: "#015064",
    stroke: "#00A8B8",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__h",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 450,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__i",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 450,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__h)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__i)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.5,
    cy: 648.5,
    fill: "#015064",
    stroke: "#00A8B8",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__j",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 486,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__k",
    width: 454,
    height: 396.9,
    x: -137.5,
    y: 486,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__j)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__k)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 684.5,
    fill: "#015064",
    stroke: "#007782",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__l",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 486,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__m",
    width: 454,
    height: 396.9,
    x: 316.5,
    y: 486,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__l)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__m)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.5,
    cy: 684.5,
    fill: "#015064",
    stroke: "#007782",
    strokeWidth: 25,
    rx: 214.5,
    ry: 186
  }))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__n",
    width: 176.9,
    height: 129.3,
    x: 272.2,
    y: 308,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__o",
    width: 176.9,
    height: 129.3,
    x: 272.2,
    y: 308,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__n)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 11,
    d: "m436 403.2-5 28.6M291 341.5l-11 62M332.9 384.1l-4.3 27.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__p",
    x1: -670.75,
    x2: -671.59,
    y1: 164.4,
    y2: 164.49,
    gradientTransform: "matrix(-184.16 -32.472 -11.461 64.997 -121359 -32126)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EE2700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__p)",
    fillRule: "evenodd",
    d: "m344.1 363 97.7 17.2c5.8 2.1 8.2 6.1 7.1 12.1s-4.7 9.2-11 9.9l-106-18.7-57.5-59.2c-3.2-4.8-2.9-9.1.8-12.8s8.3-4.4 13.7-2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 7,
    d: "m428.2 384.5.9-6.5M395.2 379.5l.9-6.5M362.2 373.5l.9-6.1M324.2 351.3l4.2-3.9M303.2 331.3l4.2-3.9"
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__q",
    width: 280.6,
    height: 317.4,
    x: 73.2,
    y: 113.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__r",
    width: 280.6,
    height: 317.4,
    x: 73.2,
    y: 113.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__q)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__r)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__s",
    x1: -672.16,
    x2: -672.16,
    y1: 165.03,
    y2: 166.03,
    gradientTransform: "matrix(-100.18 48.861 97.976 200.88 -83342 -93.059)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A17500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2100"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__s)",
    fillRule: "evenodd",
    d: "M192.3 203c8.1 37.3 14 73.6 17.8 109.1 3.8 35.4 2.8 75.1-3 119.2l61.2-16.7c-15.6-59-25.2-97.9-28.6-116.6s-10.8-51.9-22.1-99.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#2F8A00"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__t",
    x1: -660.23,
    x2: -660.23,
    y1: 166.72,
    y2: 167.72,
    gradientTransform: "matrix(92.683 4.8573 -2.0259 38.657 61680 -3088.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__t)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M195 183.9s-12.6-22.1-36.5-29.9q-23.85-7.8-55.5 11.1c15.9 14.3 29.5 22.6 40.7 24.9 16.8 3.6 51.3-6.1 51.3-6.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__u",
    x1: -661.36,
    x2: -661.36,
    y1: 164.18,
    y2: 165.18,
    gradientTransform: "matrix(110 5.7648 -6.3599 121.35 73933 -15933)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__u)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M194.9 184.5s-47.5-8.5-83.2 15.7c-23.8 16.2-34.3 49.3-31.6 99.4 30.3-27.8 52.1-48.5 65.2-61.9 19.8-20.2 49.6-53.2 49.6-53.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__v",
    x1: -656.79,
    x2: -656.79,
    y1: 165.15,
    y2: 166.15,
    gradientTransform: "matrix(62.954 3.2993 -3.5023 66.828 42156 -8754.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__v)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M195 183.9c-.8-21.9 6-38 20.6-48.2s29.8-15.4 45.5-15.3c-6.1 21.4-14.5 35.8-25.2 43.4S211.5 178 195 183.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__w",
    x1: -663.07,
    x2: -663.07,
    y1: 165.44,
    y2: 166.44,
    gradientTransform: "matrix(152.47 7.9907 -3.0936 59.029 101884 -4318.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__w)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M194.9 184.5c31.9-30 64.1-39.7 96.7-29s50.8 30.4 54.6 59.1c-35.2-5.5-60.4-9.6-75.8-12.1-15.3-2.6-40.5-8.6-75.5-18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__x",
    x1: -662.57,
    x2: -662.57,
    y1: 164.44,
    y2: 165.44,
    gradientTransform: "matrix(136.46 7.1517 -5.2163 99.533 91536 -11442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__x)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M194.9 184.5c35.8-7.6 65.6-.2 89.2 22s37.7 49 42.3 80.3c-39.8-9.7-68.3-23.8-85.5-42.4s-32.5-38.5-46-59.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__y",
    x1: -656.43,
    x2: -656.43,
    y1: 163.86,
    y2: 164.86,
    gradientTransform: "matrix(60.866 3.1899 -8.7773 167.48 41560 -25168)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90FF57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tanstack-background-logo_svg__y)",
    fillRule: "evenodd",
    strokeWidth: 13,
    d: "M194.9 184.5c-33.6 13.8-53.6 35.7-60.1 65.6s-3.6 63.1 8.7 99.6c27.4-40.3 43.2-69.6 47.4-88s5.6-44.1 4-77.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M196.5 182.3c-14.8 21.6-25.1 41.4-30.8 59.4s-9.5 33-11.1 45.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M194.9 185.7c-24.4 1.7-43.8 9-58.1 21.8s-24.7 25.4-31.3 37.8M204.5 176.4c29.7-6.7 52-8.4 67-5.1s26.9 8.6 35.8 15.9M196.5 181.4c20.3 9.9 38.2 20.5 53.9 31.9s27.4 22.1 35.1 32"
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__z",
    width: 532,
    height: 633,
    x: 50.5,
    y: 399,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__A",
    width: 532,
    height: 633,
    x: 50.5,
    y: 399,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__z)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__A)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__B",
    x1: -666.06,
    x2: -666.23,
    y1: 163.36,
    y2: 163.75,
    gradientTransform: "matrix(532 0 0 633 354760 -102959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C8700"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.5,
    cy: 715.5,
    fill: "url(#tanstack-background-logo_svg__B)",
    rx: 266,
    ry: 316.5
  }))), _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tanstack-background-logo_svg__C",
    width: 288,
    height: 283,
    x: 391,
    y: -24,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "tanstack-background-logo_svg__D",
    width: 288,
    height: 283,
    x: 391,
    y: -24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tanstack-background-logo_svg__C)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 316.5,
    r: 316.5,
    fill: "#fff"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tanstack-background-logo_svg__D)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__E",
    x1: -664.56,
    x2: -664.56,
    y1: 163.79,
    y2: 164.79,
    gradientTransform: "matrix(227 0 0 227 151421 -37204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D00"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 565.5,
    cy: 89.5,
    r: 113.5,
    fill: "url(#tanstack-background-logo_svg__E)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__F",
    x1: -644.5,
    x2: -645.77,
    y1: 342,
    y2: 342,
    gradientTransform: "matrix(30 0 0 1 19770 -253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__F)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "M427 89h-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__G",
    x1: -641.56,
    x2: -642.83,
    y1: 196.02,
    y2: 196.07,
    gradientTransform: "matrix(26.5 0 0 5.5 17439 -1025.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__G)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "M430.5 55.5 404 50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__H",
    x1: -643.73,
    x2: -645,
    y1: 185.83,
    y2: 185.9,
    gradientTransform: "matrix(29 0 0 8 19107 -1361)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__H)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "m431 122-29 8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__I",
    x1: -638.94,
    x2: -640.22,
    y1: 177.09,
    y2: 177.39,
    gradientTransform: "matrix(24 0 0 13 15783 -2145)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__I)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "m442 153-24 13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__J",
    x1: -633.42,
    x2: -634.7,
    y1: 172.41,
    y2: 173.31,
    gradientTransform: "matrix(20 0 0 19 13137 -3096)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__J)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "m464 180-20 19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__K",
    x1: -619.05,
    x2: -619.52,
    y1: 170.82,
    y2: 171.82,
    gradientTransform: "matrix(13.83 0 0 22.85 9050 -3703.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__K)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "m491.4 203-13.9 22.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__L",
    x1: -578.5,
    x2: -578.63,
    y1: 170.31,
    y2: 171.31,
    gradientTransform: "matrix(7.5 0 0 24.5 4860 -3953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__L)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "M524.5 219.5 517 244"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tanstack-background-logo_svg__M",
    x1: 666.5,
    x2: 666.5,
    y1: 170.31,
    y2: 171.31,
    gradientTransform: "matrix(.5 0 0 24.5 231.5 -3944)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#tanstack-background-logo_svg__M)",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 12,
    d: "m564.5 228.5.5 24.5"
  }))));
};
export default SvgTanstackBackgroundLogo;